var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"pb-0"},[_c('span',{staticClass:"headline"},[_vm._v("Sign in Options")])]),_c('v-card-text',{staticClass:"py-2"},[_c('div',{attrs:{"id":"auth-container"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }